import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import * as styles from './topBanner.module.scss'

export default () => {
  const { site: { siteMetadata: { topBanner: { content, show} } } } = useStaticQuery(graphql`
  {
    site {
      siteMetadata {
        topBanner {
          content
          show
        }
      }
    }
  }`)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const setTopBannerHeight = () => {
        const topBanner = document.querySelector('#top-banner')
      
        if (topBanner) {
          document.documentElement.style.setProperty('--top-banner-height', Math.round(topBanner.offsetHeight * 100) / 100 + 'px')
        }
      }
  
      setTopBannerHeight()
    }
   
  }, [show])

  if (!show) {
    return null
  }

  return <div className={styles.topBanner} id="top-banner">
    <span className={styles.icon}>i</span>
    <ReactMarkdown className={styles.content}>{content}</ReactMarkdown>
  </div>
}